import type {
  EnumKey,
  EnumValue,
  ObjVal,
} from '@repo/internal-tools-type-utils/src/utils.ts'

export type TShirtSize =
  | `${number}xs`
  | 'xs'
  | 'sm'
  | 'md'
  | 'lg'
  | 'xl'
  | `${number}xl`

/**
 * Allow <SIZE> or XXX_<SIZE> for keys
 */
export type TShirtSizeEnumKey = EnumKey<TShirtSize>
/**
 * <size> or xxx-<size> for values
 */
export type TShirtSizeEnumValue = EnumValue<TShirtSize>

export type TypographySize = TShirtSize | `h${number}`

export type TypographySizeEnumKey = EnumKey<TypographySize>

export type TypographySizeEnumValue = EnumValue<TypographySize>

export const COMPONENT_CONTEXTS = {
  STANDALONE: 'standalone',
  CONTAINED: 'contained',
} satisfies Record<EnumKey, EnumValue>

export type ComponentContexts = typeof COMPONENT_CONTEXTS
export type ComponentContext = ObjVal<ComponentContexts>

export const COMPONENT_DIRECTION = {
  HORIZONTAL: 'horizontal',
  VERTICAL: 'vertical',
} satisfies Record<EnumKey, EnumValue>

export type ComponentDirections = typeof COMPONENT_DIRECTION
export type ComponentDirection = ObjVal<ComponentDirections>

export const COMPONENT_DENSITIES = {
  COMFORT: 'comfort',
  CONDENSED: 'condensed',
} satisfies Record<EnumKey, EnumValue>

export type ComponentDensities = typeof COMPONENT_DENSITIES
export type ComponentDensity = ObjVal<ComponentDensities>
